'use strict';

import './ProgressIndicator.less';

import React from 'react';
import PropTypes from 'prop-types';

export default class ProgressIndicator extends React.Component {
	constructor(props) {
		super(props);
	}

	onSelect(index) {
		return () => this.props.onSelect(index);
	}

	render() {
		const { steps, index, linear, disabled } = this.props;

		return (
			<div className="ProgressIndicator">
				{steps.map((step, i) => {
					const indicatorState = index === i ? 'current' : linear && i < index ? 'past' : '';
					return (
						<div
							className={`ProgressIndicator__dot ProgressIndicator__dot--${indicatorState} ${
								disabled ? '' : 'ProgressIndicator__dot--clickable'
							}`}
							key={i}
							onClick={disabled ? () => null : this.onSelect(i)}
						/>
					);
				})}
			</div>
		);
	}
}

ProgressIndicator.propTypes = {
	index: PropTypes.number.isRequired,
	steps: PropTypes.array.isRequired,
	onSelect: PropTypes.func,
	linear: PropTypes.bool,
	disabled: PropTypes.bool
};
